
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/contracts/cli",
      function () {
        return require("private-next-pages/events/contracts/cli.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/contracts/cli"])
      });
    }
  